import { createAction } from 'redux-actions';

import {
  LOAD_STAFF_DETAIL,
  LOAD_STAFF_DETAIL_SUCCESS,
  LOAD_STAFF_DETAIL_ERROR,
  CREATE_STAFF,
  CREATE_STAFF_SUCCESS,
  CREATE_STAFF_ERROR,
  UPDATE_STAFF,
  UPDATE_STAFF_SUCCESS,
  UPDATE_STAFF_ERROR,
} from './type';

//Load list staff
export const loadStaffDetailAction = createAction(LOAD_STAFF_DETAIL);
export const loadStaffDetailSuccessAction = createAction(
  LOAD_STAFF_DETAIL_SUCCESS,
);
export const loadStaffDetailErrorAction = createAction(LOAD_STAFF_DETAIL_ERROR);

//Create
export const createStaffAction = createAction(CREATE_STAFF);
export const createStaffSuccessAction = createAction(CREATE_STAFF_SUCCESS);
export const createStaffErrorAction = createAction(CREATE_STAFF_ERROR);

//Update staff
export const UpdateStaffAction = createAction(UPDATE_STAFF);
export const UpdateStaffSuccessAction = createAction(UPDATE_STAFF_SUCCESS);
export const UpdateStaffErrorAction = createAction(UPDATE_STAFF_ERROR);
